/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2022-11-14 14:47:07
 * @LastEditors: changfeng
 * @LastEditTime: 2024-07-26 14:39:15
 */
import logo from '@/assets/logo.png';
import { RoleEnum } from '@/utils/constant';
import { LogoutOutlined } from '@ant-design/icons';
import { history, useModel } from '@umijs/max';
import type { MenuProps } from 'antd';
import { Avatar, Dropdown, Menu, Space, Spin } from 'antd';
import styles from './index.less';

/**
 * 退出登录，并且将当前的 url 保存
 */
const loginOut = async () => {
  // 删除cookie和token

  // const { setToken } = useModel('global');
  localStorage.setItem('Authorization', '');
  // setToken('');
  const { state } = history.location;
  console.log('history.location', history.location);

  // Note: There may be security issues, please note

  if (window.location.pathname !== '/login' && !state) {
    history.push('/login', { from: history.location.pathname });
  }
};

const AvatarDropdown = () => {
  const { initialState } = useModel('@@initialState');

  const loading = (
    <span className={`${styles.action} ${styles.account}`}>
      <Spin
        size="small"
        style={{
          marginLeft: 8,
          marginRight: 8,
        }}
      />
    </span>
  );

  if (!initialState) {
    return loading;
  }

  const { currentUser } = initialState;

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <Menu>
          <Menu.Item key="logout" onClick={() => loginOut()}>
            <LogoutOutlined />
            退出登录
          </Menu.Item>
        </Menu>
      ),
    },
  ];
  return (
    <div className="headerContainer">
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          verticalAlign: 'middle',
        }}
      >
        <div>
          <img style={{ width: 30, height: 30 }} src={logo} />
        </div>
        <h2 className="logo-title">All In One 电商管理系统</h2>
      </div>
      <Dropdown menu={{ items }}>
        <span className={`${styles.action} ${styles.account}`}>
          <a onClick={(e) => e.preventDefault()}>
            <Space>
              <Avatar
                size="small"
                className={styles.avatar}
                src="https://gw.alipayobjects.com/zos/antfincdn/XAosXuNZyF/BiazfanxmamNRoxxVxka.png"
                alt="avatar"
              />
              <div className={`${styles.name} anticon nameContainer`}>
                <span
                  style={{
                    fontSize: 14,
                    display: 'block',
                    padding: '4px 0',
                    color: '#333333',
                  }}
                >
                  {currentUser?.email}
                </span>
                <br />
                <span style={{ fontSize: 12, color: '#666666' }}>
                  {RoleEnum[currentUser?.roleName as keyof typeof RoleEnum]}
                </span>
              </div>
            </Space>
          </a>
        </span>
      </Dropdown>
    </div>
  );
};

export default AvatarDropdown;
